import { render, staticRenderFns } from "./StoreOrders.vue?vue&type=template&id=4e65f00d&scoped=true"
import script from "./StoreOrders.vue?vue&type=script&lang=js"
export * from "./StoreOrders.vue?vue&type=script&lang=js"
import style0 from "./StoreOrders.vue?vue&type=style&index=0&id=4e65f00d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e65f00d",
  null
  
)

export default component.exports